import Loader from './Loader/Loader';


const PageSpinner = () =>
    <div className='container-fluid h-100  d-flex'>
        <div className='row w-100 justify-content-center align-self-center'>
            <div className='col-sm-6 col-md-6 col-lg-6 col-xl-6 text-center'>
                <Loader />
            </div>
        </div>
    </div>



export default PageSpinner;
